var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.link ? 'inertia-link' : 'div',_vm._b({tag:"component",class:_vm.className},'component',_vm.$attrs,false),[_c('sg-spacing',{attrs:{"x-sm":_vm.padded,"y-sm":_vm.padded}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }